import React from 'react';
import { Navigate } from 'react-router-dom';

import { permissionList } from '../../../shared-functions/JWTDocodeFunction';
import getToken from '../../../utils/helpers';

/**
 * Handle the auth guard for check permission function
 * @param {object} properties - The properties
 * @param {any} properties.permission - The required permissions
 * @param {any} properties.Component - The component to render
 * @returns {any} The rendered component or redirect
 */
function AuthGuard({ permission, Component }: { permission: string[]; Component: JSX.Element }) {
  // console.log('AuthGuard - required permissions:', permission);
  // return Component
  const token = getToken();

  if (!token) {
    return <Navigate to="/login/credentials" replace />;
  }

  if (permission.length === 0) return Component;

  const permissionLists = permissionList();

  const permissionAssign = permission?.find((per) => permissionLists?.includes(per));

  return permissionAssign ? Component : <Navigate to="/login/credentials" />; // <Navigate to="/login" />
}

export default AuthGuard;
